<div class="container mt-4">

  <div class="row mb-3">
    <div class="col-12">
      <h1>
        Privacy policy
      </h1>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-12">

      <p>
        This website <a href="https://www.identibase.co.uk">www.identibase.co.uk</a> and
        <a href="https://www.identichip.co.uk">www.identichip.co.uk</a> are owned and operated by Identicare Limited
        (“we”/”us”).
      </p>
      <p>
        We are committed to protecting and respecting your privacy.
        We do not use personal identifiable information such as names,
        telephone numbers, or emails in principle, unless the processing
        of personal information is supported by your consent, a legitimate
        interest, a contract or legal obligation.
      </p>
      <p>
        This Privacy Policy applies to personal data that you provide to us
        or which is derived from the Personal Data as outlined below.
      </p>
      <p>
        This policy explains our information practices and the choices you
        can make about the way your information is processed by us.
      </p>

      <h4 class="my-3">
        The information we collect
      </h4>

      <p>
        We process the personal data we collect about you for various reasons.
        We have set out in the table below the reasons why we process your
        personal data and the associated legal bases we rely upon to legally
        permit us to process your personal data.
      </p>

      <div>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th scope="col" class="w-50">
                You may give us information about
                yourself by:
              </th>
              <th scope="col" class="w-50">
                Legal basis for purpose of processing:
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                filling in forms (e.g. the identibase
                registration form completed when your
                pet is micro-chipped);
              </td>
              <td>
                Performance of a Contract<br><br>
                Legitimate Interest
              </td>
            </tr>
            <tr>
              <td>
                submitting information to us via the
                website or through your use of the
                website;
              </td>
              <td>
                Consent<br><br>
                Legitimate Interest
              </td>
            </tr>
            <tr>
              <td>
                submitting information via our
                discussion boards or social media
                channels (e.g. Facebook; Twitter);
              </td>
              <td>
                Legitimate Interest
              </td>
            </tr>
            <tr>
              <td>
                purchasing goods or services via the
                website;
              </td>
              <td>
                Performance of a Contract
              </td>
            </tr>
            <tr>
              <td>
                participating in competitions,
                promotions or surveys run by us; or
              </td>
              <td>
                Consent<br><br>
                Legitimate Interest
              </td>
            </tr>
            <tr>
              <td>
                corresponding with us by phone, e-mail
                or otherwise (e.g. when updating your
                registered contact details, reporting a
                lost pet or during the process of
                repatriating a pet).
              </td>
              <td>
                Performance of a Contract<br><br>
                Legitimate Interest
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <p>The information you give us may include your:</p>

      <ul>
        <li>name</li>
        <li>address</li>
        <li>e-mail address</li>
        <li>telephone number</li>
        <li>financial and credit card information (these details are not stored once
        processed)</li>
      </ul>

      <p>
        You may also provide us with information about other individuals and businesses
        (e.g. a contact telephone number for your partner). You confirm that any such
        information that you provide to us is done so with the consent of the relevant
        individual or business and you have brought this Privacy Policy to their attention.
      </p>
      <p>
        You do not have to give us any of the personal data set out above but, if you do
        not provide us with certain information, we may not be able to provide you with
        the products or services that you have requested from us or deal with your query.
      </p>
      <p>
        When you visit our websites, we can automatically collect:
      </p>

      <ul>
        <li>technical information, the type of browser you are using, the type of operating
        system you are using, and the domain name of your Internet service provider</li>
        <li>information about your visit, including the full Uniform Resource Locators (URL)
        clickstream to, through and from our site (including date and time); products you
        viewed or searched for</li>
        <li>information about the performance of our pages such as page response times,
        download errors, page interaction information</li>
      </ul>

      <p>
        With respect to each time you contact our customer support centre we may
        automatically collect your telephone number.
      </p>

      <h4 class="my-3">
        Information we receive from other sources
      </h4>
      <p>
        We may receive information about you if you use any of the other websites we or our
        group companies operate or the other services or products we or our group companies provide.
      </p>
      <p>
        We are also working closely with third parties (including, for example, business partners,
        sub-contractors in technical, payment and delivery services, advertising networks, analytics
        providers and search information providers) and may receive information about you from them.
      </p>
      <p>
        Where permitted by data protection laws, we may combine this information with the information
        you give to us or we collect about you and use this combined information for the purposes set
        out below.
      </p>

      <h3 class="my-4">
        How we normally use information about you
      </h3>
      <!-- <h4 class="my-3"> -->
       <p>We will use the information you give to us:</p>
      <!-- </h4> -->

      <ul>
        <li>to carry out our obligations to you in connection with the provision of the
          identibase service or identichip supply;
        </li>
        <li>to carry out our obligations to you in connection with the provision of the
          identialert, identifind, or identibase+ services (if you subscribe for one of
          these services);
        </li>
        <li>
          to provide you with information, products and services that you request from us;
        </li>
        <li>
          for invoicing, delivery and customer support purposes;
        </li>
        <li>
          to provide you with information about other goods and services we offer that
          are similar to those that you have already purchased or enquired about;
        </li>
        <li>
          to provide you with information about goods or services we feel may interest you;
        </li>
        <li>
          to notify you about changes to our products and services;
        </li>
        <li>
          to optimise and improve our internal systems and processes;
        </li>
        <li>
          to support the availability of our products and services;
        </li>
        <li>
          to ensure that content from our website is presented in the most effective manner
          for you and for your computer/other electronic device.
        </li>
      </ul>

      <p>
        We will use the information we collect about you:
      </p>

      <ul>
        <li>
          to administer our website and for internal operations, including troubleshooting,
          data analysis, testing, research, statistical and survey purposes;
        </li>
        <li>
          to improve our website to ensure that content is presented in the most effective
          manner for you and for your computer/other electronic device;
        </li>
        <li>
          to allow you to participate in interactive features available on our website when
          you choose to do so;
        </li>
        <li>
          as part of our efforts to keep our website safe and secure;
        </li>
        <li>
          to measure or understand the effectiveness of advertising we serve to you and
          others and to deliver relevant advertising to you;
        </li>
        <li>
          to make suggestions and recommendations to you about goods or services that may
          interest you.
        </li>
      </ul>
      <p>
        We use non-personally identifiable information to analyse site usage (such as
        aggregated information on the pages visited by our users), which allows us to
        improve the design and content of our website.
      </p>

      <h4 class="my-3">
        Marketing Communications
      </h4>
      <p><u>If you are a corporate contact</u></p>
      <p>
        We, and our group companies, may contact you by e-mail, SMS, telephone or post
        providing information about ] microchips, where we (or our group companies) have
        a legitimate interest to do and this is permitted by data protection laws.
      </p>

      <p><u>If you are a consumer</u></p>
      <p>
        Unless you have opted-out, we may contact you by e-mail, SMS or telephone with
        information about goods and services we offer that are similar to those that you
        have already purchased or enquired about.
      </p>
      <p>
        Where you have consented, we may also contact you by e-mail, SMS or telephone
        providing information about offers and promotions offered by carefully selected
        third parties.
      </p>
      <p>
        Where you have consented to receive marketing communications from us via e-mail,
        SMS and/or telephone, you can withdraw your consent at any time by using the opt-
        out link at the bottom of any e-mail or SMS, changing your preferences through
        your account at <a href="https://identibase.co.uk/account">https://identibase.co.uk/account</a>
        (if you are an identibase customer) or contacting us using the details in this policy.
      </p>
      <p>
        We may also contact you by post providing information about freebies, offers and
        useful advice tailored to you and your pet, where we have a legitimate interest
        to do and this is permitted by data protection laws.
      </p>

      <h4 class="my-3">
        Disclosure of your information
      </h4>
      <p>
        We may share your information with selected third parties including:
      </p>
      <ul>
        <li>our group companies;</li>
        <li>business partners, suppliers and sub-contractors for the purpose of performing
        any contractual obligations owed to you as our customer;</li>
        <li>vets and/or rescue centres for reunification purposes;</li>
        <li>advertisers and advertising networks that require the information to select and
        serve relevant adverts to you; or</li>
        <li>analytics and search engine providers that assist us in the improvement and
        optimisation of our website.</li>
      </ul>

      <p>
        We do not disclose information about identifiable individuals to our advertisers, but
        we may provide them with aggregate information about our customers or visitors to
        our website. We may also use aggregate information to help advertisers reach the
        kind of audience they want to target (e.g. dog owners in a particular postcode).
      </p>
      <p>
        We may disclose your personal information to third parties:
      </p>

      <ul>
        <li>if we sell or buy any business or assets, in which case we may disclose your
        personal data to the seller or buyer of such business or assets;</li>
        <li>if we or our business assets are acquired by a third party, in which case
        personal data held by us about our customers may be one of the transferred
        assets;</li>
        <li>
          if we are under a duty to disclose or share your information in order to:
          <ul>
            <li>comply with any legal obligation (e.g. complying with any court order or
            law enforcement request);</li>
            <li>enforce or apply our website terms of use or any other agreements
            between us;</li>
            <li>to protect the rights, property, or safety of our business, our customers or
            others (e.g. exchanging information with other companies and
            organisations for the purposes of crime prevention).</li>
          </ul>
        </li>
      </ul>

      <h4 class="my-3">
        Where we store your information
      </h4>
      <p>
        The information that we have from you is stored and processed within the UK and
        the EU by personnel engaged by us (e.g. by our employees and/or by our third party
        suppliers).
      </p>
      <p>
        Although our employees are all based in the UK and the EU, the information that we
        have from you may be transferred, stored and/or processed at a destination outside
        the EU and the UK by our third party suppliers.
      </p>
      <p>
        If we do this, we have procedures in place to ensure your data receives the
        necessary protections. Any transfer of your personal data will follow
        applicable laws and we will treat the information according to the principles
        set out in this Privacy Policy. For transfers to service providers outside the
        UK or the European Economic Area where no adequacy decision applies, we use
        standard contractual clauses or other approved transfer mechanisms to protect
        your personal information.
      </p>
      <p>
        Where we have given you (or where you have chosen) a password which enables
        you to access certain parts of our website, you are responsible for keeping this
        password confidential. We ask you not to share your password with anyone as this
        may jeopardise the security of your information.
      </p>

      <h4 class="my-3">
        Data retention and deletion
      </h4>
      <p>
        We keep your personal data only as long as necessary to (i) provide you with
        the identibase service and identichip supplies and (ii) for legitimate and
        essential business purposes.
      </p>
      <p>
        All people or companies that use our services will have their contact details kept in
        our systems as these are required for rendering the service. The retention period is
        based on our legal obligations and in accordance with our Personal Data Retention
        Policy.
      </p>

      <h4 class="my-3">
        Collection of information by third-party sites and sponsors
      </h4>
      <p>
        Our website contains links to other sites whose information practices may be
        different to ours. Visitors should consult these other sites&#39; privacy notices as we have
        no control over information that is submitted to, or collected by, these third parties.
      </p>

      <h4 class="my-3">
        Cookies
      </h4>
      <p>
        <a routerLink="/cookies">Click here to visit the Cookie Policy</a> for identibase.
      </p>
      <p>
        <a href="https://www.identichip.co.uk/cookie-policy/">Click here to visit the Cookie Policy</a> for identichip.
      </p>

      <h4 class="my-3">
        Our commitment to security
      </h4>
      <p>
        We employ security measures to prevent unauthorised access to information that we
        collect.
      </p>
      <p>
        If you have any concerns that your information is incorrect or has been disclosed,
        please contact us so that we can correct the data, investigate any issue and take any
        action necessary to prevent such issue recurring in future.
      </p>

      <h4 class="my-3">
        Your rights
      </h4>
      <p>
        In accordance with data protection law concerning the processing of personal data
        you are afforded the following rights:
      </p>
      <ul>
        <li>Right of access - the right to be informed of, and request access to, the
        personal data we process about you;</li>
        <li>Right to rectification - the right to request that we amend or update your
        personal data where it is inaccurate or incomplete;</li>
        <li>Right to erasure - the right to request that we delete your personal data (as
        long as we are not obliged to retain it for legal or contractual purposes);</li>
        <li>Right to restrict - the right to request that we temporarily or permanently stop
        processing all or some of your personal data;</li>
        <li>Right to data portability - the right to request a copy of your personal data in
        electronic format and the right to transmit that personal data for use in another
        party&#39;s service; and</li>
      </ul>

      <h4 class="my-3">
        Your right to object
      </h4>
      <ul>
        <li>Right to object - the right, at any time, to object to us processing your personal
        data on grounds relating to your particular situation and the right to object to
        your personal data being processed for direct marketing purposes.</li>
      </ul>
      <p>
        If you are not happy with the way that we use your data, you have the right to lodge
        a complaint with your data protection regulator. In the UK, this is the Information
        Commissioner’s Office (the “ICO”). You can make a complaint to the ICO by calling
        their helpline on 0303 123 1113 or on their website at www.ico.org.uk/concerns. We
        would, however, appreciate the chance to deal with your concerns before you
        approach the ICO or, (if you’re based outside of the UK, your data protection
        regulator), so please do contact us in the first instance using the contact details at
        the end of this Privacy Policy.
      </p>

      <h4 class="my-3">
        How to contact us
      </h4>
      <p>
        If you have any questions or concerns about this Privacy Policy or you wish to
        exercise your rights under data protection law, please contact us at
        <a href="mailto:privacy@identibase.co.uk">privacy&#64;identibase.co.uk.</a>
      </p>

      <h4 class="my-3">
        Revisions to our privacy policy
      </h4>
      <p>
        We reserve the right to revise this policy in whole or in part from time to time. Please
        review the policy periodically for changes.
      </p>
    </div>
  </div>

</div>
